'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMessagesUpdateMessage = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _messageTypes = require('../constants/messageTypes');

var _messageTypes2 = require('../../pubnub-message/constants/messageTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isMessagesUpdateMessage = exports.isMessagesUpdateMessage = function isMessagesUpdateMessage(message) {
  return (0, _get2.default)(_messageTypes2.MESSAGE_TYPE_ID, message) === _messageTypes.MESSAGES_UPDATED;
};